export const MENSMARKET_HOME_DOCUMENT_ID = 'MENSMARKET_HOME';

export const MENSMARKET_HOME_ROUTE = '/configuracoes/mens/home';

export const MENSMARKET_HOME_BANNERS_PATH = '/mensmarket/home/banners/';

export const MENSMARKET_HOME_HIGHLIGHTS_PATH = '/mensmarket/home/highlights/';

export const MENSMARKET_HOME_HIGHLIGHT_IMAGE_ACCEPT =
  '.svg,image/svg+xml,.webp,.ico';

export function mapMensNewHomeDisplayRuleText(ruleObj: Record<string, boolean>): string {
  const ruleMapping: Record<string, string> = {
    subscriberBuyer: 'Assinante já comprou',
    notSubscriber: 'Não assinante',
    subscriberNotBuyer: 'Assinante nunca comprou',
    topBadgeSubscriber: 'Assinante top badge',
    beautyProfile: 'Perfil de beleza'
  };

  for (const key in ruleObj) {
    if (!Object.prototype.hasOwnProperty.call(ruleObj, key)) {
      continue;
    }
    const label = ruleMapping[key] || key;
    const value = ruleObj[key] ? 'Sim' : 'Não';
    return `${label}: ${value}`;
  }

  return '';
}

export function getMensNewHomeEditRoute(
  sectionType: string,
  sectionId: string
): string | null {
  const routesByType: Record<string, string> = {
    COLLECTION: `${MENSMARKET_HOME_ROUTE}/collection/${sectionId}`,
    LIVE: `${MENSMARKET_HOME_ROUTE}/live/${sectionId}`,
    BRANDS: `${MENSMARKET_HOME_ROUTE}/brands/${sectionId}`,
    CAROUSEL: `${MENSMARKET_HOME_ROUTE}/carousel/${sectionId}`,
    BANNER: `${MENSMARKET_HOME_ROUTE}/banner/${sectionId}`,
    INFOBARS: `${MENSMARKET_HOME_ROUTE}/infobar/${sectionId}`,
    HIGHLIGHTS: `${MENSMARKET_HOME_ROUTE}/highlights/${sectionId}`
  };

  return routesByType[sectionType] ?? null;
}
